<template>
      <!--<div class="container" :style="{backgroundImage: 'url(' + require('./assets/photo/topics/road.jpg') + ')'}">-->
      <div v-bem.container  v-bg-set   :style="{backgroundImage: 'url(' + require('../assets/photo/topics/road-s.jpg') + ')'}" :data-bg-src-ms="require('../assets/photo/topics/road-m.jpg')" :data-bg-src-ls="require('../assets/photo/topics/road-l.jpg')" :data-bg-src-xs="require('../assets/photo/topics/road-x.jpg')">
        <div v-bem.strip="{'default': true, 'left': true}"></div>
				<div v-bem.strip="{'default': true, 'top': true}"></div>
				<div v-bem.strip="{'default': true, 'right': true}"></div>
        <div v-bem.strip="{'default': true, 'bottom': true}"></div>
        <div v-bem.coverage="{'full':true,'gradient':true}">
          <div v-bem.standart="'default'" ><img v-bem.standart-img="'default'" src="../assets/standart.svg" ></div>
          <div v-bem.main-title="'default'">Cтратегические инициативы Президента России </div>
					<!--<div class="marker-container">-->
						<!--<h1><a href="#start">&or;</a></h1>-->
					<!--</div>-->
			 </div>
			</div>
</template>
<script>
export default {
  name: 'start-screen',
  props: []
}
</script>
<style>
@import '../style.css';
@use saladcss-bem;
@use lost;

@define-mixin gradient {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#294b8e+0,0b212f+100 */
  background: rgb(41,75,142); /* Old browsers */
  background: -moz-radial-gradient(center, ellipse cover, rgba(41,75,142,1) 0%, rgba(11,33,47,1) 100%); /* FF3.6-15 */
  background: -webkit-radial-gradient(center, ellipse cover, rgba(41,75,142,1) 0%,rgba(11,33,47,1) 100%); /* Chrome10-25,Safari5.1-6 */
  background: radial-gradient(ellipse at center, rgba(41,75,142,1) 0%,rgba(11,33,47,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#294b8e', endColorstr='#0b212f',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}
@define-mixin no-decor-a {
a, a:active, a:hover{
    color: white;
    text-decoration:none;
    }
}
@keyframes bouncing{
  0%  { bottom: 0; }
  100% { bottom: 15px; }
}


.marker-container {
/* background-color:rgba(5,5,5,0.5);*/
position:absolute;
bottom:2vh;
width:100%;
margin-left: 50%;
margin-right: 50%;

@mixin no-decor-a;
animation:bouncing 0.5s cubic-bezier(0.1,0.25,0.1,1) 0s infinite alternate both;
}


@b start-screen {
  @e coverage {
    @m full {
      left:0;
      top:0;
      width:100%;
      height:100vh;
      position:absolute;
      z-index:100;
    }
    @m gradient {
      @mixin gradient;
    }
  }
  @e standart {
    @m default {
      width: 90%;
      margin-left:5%;
      height:30%;
      position: absolute;
      bottom:50%;
      text-align: center;
    }
    @m left {
      width: 90%;
      margin-left:5%;
      height:30%;
      position: absolute;
      bottom:50%;
      text-align: left;
      
    }
  }
  @e standart-img {
    @m default {
      height: 100%
    }
  }
  @e main-title {
    @m default {
      position: absolute;
      top:50%;
      width:90%;
      margin-top:5%;
      margin-left:5%;
      margin-right:5%;
      color: white;
      font-family: Arial;
      font-weight: bolder;
      font-size:2rem;
      text-align:center;
    }

    @m left {
      text-align:left;
      font-size: 0.7rem;
      position: absolute;
      top:50%;
      width:70%;
      margin-top:5%;
      margin-left:5%;
      margin-right:5%;
      color: white;
      font-family: Arial;
      font-weight: bolder;
    }
  } 
}


@b strip {
  @m default {
    display:none;
  }
}


.gradient {
   @mixin gradient;
}

@media (--ms) {
  @b start-screen {
    @e coverage {
      @m full {
        position:fixed;
        z-index:300;
      }
    }
    @e main-title {
      @m default {
        margin-left: 15%;
        margin-right: 15%;
        width: 70%;
        font-size:2rem;
        text-align:center;
      }
    }
    @e container {
      left:0;
      top:0;
      width:100%;
      height:100vh;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;  
    }
    @e strip {
      @m default {
        width:300%;
        height:300vh;
        border:1px solid black;
        transform: rotateZ(-30deg);
        display:block;
      }
      @m left {
        position:fixed; 
        transform-origin:right bottom;
        background-color:#44586a;
        opacity:0.2;
        right: 70%;
        bottom: 70%;
        z-index: 100;
        opacity: 1.0;
      }
      @m right {
        position:absolute; 
        left:30%;
        top: 30%;
        transform-origin:left top;
        background-color:#cdd4db;
        opacity:0.1;
      }
      @m top {
        position:absolute; 
        left:30%;
        bottom:70%;
        transform-origin:left bottom;
        background-color:#0b212f; 
        opacity:1.0;
        @mixin gradient;
      }
      @m bottom {
        position:absolute; 
        top:30%;
        right:70%;
        transform-origin:right top;
        background-color:#a2b4c3;
        opacity:0.3
      }
    }
  }
  @b start-screen {
    @e strip {
      @m top {
        background:#44586a;
        opacity:0.2;
      }
      @m left {
        background-color: #0b212f; 
        opacity:1;
        @mixin gradient;
      }
    }
  }
}
@media (--ls) {
  @b start-screen {
    @e main-title {
      @m default {
        font-size: 3rem;
      }
      @m left {
        font-size: 1rem;
        width: 70%;
      }
    }
  }
}
@media (--xs) {
  @b start-screen {
    @e main-title {
      @m default {
        font-size: 3rem;
      }
      @m left {
        font-size: 1.4rem;
        width: 90%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/StartScreen.vue